<template>
  <div class="services">
    <div class="site-content">
      <div
        class="page-header"
        :style="{backgroundImage:`url(${require('../assets/images/subheader-4.jpg')})`}"
        style="background:no-repeat center center;"
      >
        <div class="container">
          <div class="breadc-box no-line">
            <div class="row">
              <div class="col-md-12">
                <h2 class="page-title">酒店PMS软件</h2>
                <ul id="breadcrumbs" class="breadcrumbs none-style">
                  <li>
                    <router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link>
                  </li>
                  <li class="active">产品信息</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <!-- <div class="row flex-row">
            <div class="col-sm-7 col-xs-12">
              <h4 class="text-primary">软件介绍</h4>
              <h2>B/S结构BW-V2.0酒店管理软件系统</h2>
              <p>B/S结构，即Browser/Server（浏览器/服务器）结构，是随着Internet技术的兴起，对C/S结构的一种变化或改进的结构。邦威酒店系统是纯B/S，如选用总部服务器安装模式只需要安装一个服务器，不需要在各个分店安装客户端，不需要通过VPN进行对接，系统维护开销减到最小。</p>
              <br />
            </div>
            <div class="col-sm-3 col-xs-12 col-sm-offset-2 align-self-center text-right text-mb-left">
              <div class="career-download">
                <a href="#" class="btn btn-border btn-download">
                  <span class="text-primary">下载试用</span>
                  <i class="fa fa-download"></i>
                </a>
              </div>
              <div class="industris-space-xs"></div>
            </div>
          </div> -->
          <!-- <div class="row">
						<div class="col-md-8 col-sm-12">
							<h3>邦威BWHIS2015酒店信息管理软件</h3>
							<p>BWHIS2015酒店管理系统是邦威公司集多年的软件开发经验，并充分吸取国外优秀软件Fidelio、LanMark的先进管理理念下开发而成，本着简洁、实用、易操作的指导思想，坚持稳定性、先进性、科学性、严密性的原则，彻底堵塞收银漏洞，是酒店管理的好帮手。</p>

							<p>系统平台基于WINDOWS2000/2003，客户/服务器平台数据库采用Microsoft大型数据库SQLServer，开发工具选用Delphi、PowerBuild和C三种语言，保证了系统高效率的运行。</p>

							<div class="industris-space-xs"></div>
						</div>
						<div class="col-md-4 col-sm-12">
							<img src="../assets/images/career-img.jpg" alt="">
						</div>
          </div>-->

          <!-- <div class="industris-space"></div>
          <hr /> -->

          <div class="row flex-row">
            <div class="col-sm-8 col-xs-12">
              <h2 class="no-margin-bottom">商务版</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="industris-space-50"></div>
              <div class="career-box row">
                <div class="col-md-8 col-xs-12">
                  <h3>软件介绍</h3>
                  <p>
                    适用于经济型、商务、精品型酒店，特点是功能简化，简洁而不简单，它把服务功能集中在住宿上，力求在该核心服务上精益求精，而把餐饮、购物、娱乐功能大大缩减、简化、甚至不设，投入的运营成本大幅降低。
                    <br />简单培训即可上手，对于经济型酒店来说是一套或不可缺、得心应手的酒店管理软件。
                  </p>
                  <h3>软件功能</h3>
                  <p>
                    - 预订、接待、收银、HouseKeeping、AR、会员、夜审报表等
                    <br />- 详细的用户权限，完整的档案客史管理，完善的微信订房、微会员功能
                  </p>
                </div>
                <div class="col-md-4 col-xs-12">
                  <img src="../assets/images/career-img.jpg" alt />
                </div>
              </div>
              <div class="industris-space-90 sm-hidden"></div>
            </div>
          </div>

          <hr />
          <div class="industris-space"></div>

          <div class="row flex-row">
            <div class="col-sm-8 col-xs-12">
              <h2 class="no-margin-bottom">标准版</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="industris-space-50"></div>
              <div class="career-box row">
                <div class="col-md-8 col-xs-12">
                  <h3>研发理念</h3>
                  <p>在商务版的功能基础行增加了餐饮管理模块，继承了“高星级酒店管理系统”的研发理念，同时在原有的基础上更加优化系统而开发的一套面向国内中端酒店的管理系统，餐饮管理可做到触摸屏、点菜宝、IPAD、微信扫码等多平台点餐，同时提供厨房打印、仓库进销存管理、成本卡片等。</p>
                  <h3>服务对象</h3>
                  <p>
                    - 中国大陆的宾馆、度假村等中端酒店
                    <br />- 满足客房和餐厅管理需要
                    <br />- 连接各种外围系统，包括交换机计费、电子门锁、视频点播、身份证扫描、能源管理、洗浴和娱乐中心管理系统等
                    <br />- 全面、灵活、高效
                  </p>
                </div>
                <div class="col-md-4 col-xs-12">
                  <img src="../assets/images/career-img-pos.jpg" alt />
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div class="industris-space"></div>

          <div class="row flex-row">
            <div class="col-sm-8 col-xs-12">
              <h2 class="no-margin-bottom">铂金版</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="industris-space-50"></div>
              <div class="career-box row">
                <div class="col-md-8 col-xs-12">
                  <h3>研发理念</h3>
                  <p>在标准版的功能基础上增加了娱乐设施管理（健身房、KTV、桑拿洗浴等）、人力资源管理、工程能耗管理、电话控制与电话计费等，使用管理系统领域内最稳定及最开放的平台，更加符合国内高端酒店的管理需求。</p>
                  <h3>服务对象</h3>
                  <p>
                    - 面向国内商务型、度假型、会议型、公寓型及综合旅游物业
                    <br />- 满足四星、五星等高端酒店的信息化管理需求
                    <br />- 提供给酒店高级管理人员一种全新的管理理念
                  </p>
                </div>
                <div class="col-md-4 col-xs-12">
                  <img src="../assets/images/career-img-1.jpg" alt />
                </div>
                <!-- <div class="industris-space-30"></div>
                <a href="#" class="btn btn-primary">Apply Now</a>-->
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "services_pms",
  components: {},
};
</script>

<style>
.career-box img {
  margin-top: 10%;
}
</style>



// WEBPACK FOOTER //
// src/pages/services_pms.vue